import { LitElement, html, css } from 'lit';

export class CrusherSkillBar extends LitElement {
  static styles = css`
    :host {
      display: block;
      margin-bottom: var(--crusher-skill-bar-margin-bottom, var(--crusher-spacing-6));
    }
    .header {
      display: flex;
      justify-content: space-between;
      align-items: baseline;
      margin-bottom: var(--crusher-skill-bar-label-gap, var(--crusher-spacing-2));
    }
    .label {
      margin: var(--crusher-skill-bar-label-margin, 0);
      font-weight: var(--crusher-skill-bar-label-weight, var(--crusher-font-weight-medium));
      font-size: var(--crusher-skill-bar-label-size, var(--crusher-font-size-base));
      line-height: var(--crusher-skill-bar-label-line-height, normal);
      color: var(--crusher-skill-bar-label-color, var(--crusher-text-primary));
      text-transform: var(--crusher-skill-bar-label-transform, none);
    }
    .percent-text {
      font-size: var(--crusher-skill-bar-percent-size, var(--crusher-font-size-sm));
      font-weight: var(--crusher-skill-bar-percent-weight, var(--crusher-font-weight-regular, 400));
      color: var(--crusher-skill-bar-percent-color, var(--crusher-text-secondary));
      line-height: var(--crusher-skill-bar-percent-line-height, normal);
    }
    .progress {
      position: relative;
      background-color: var(--crusher-skill-bar-track-bg, var(--crusher-border-primary));
      height: var(--crusher-skill-bar-track-height, var(--crusher-spacing-2));
      border-radius: var(--crusher-skill-bar-track-radius, var(--crusher-radius-full));
      width: 100%;
      overflow: hidden;
      box-shadow: var(--crusher-skill-bar-track-shadow, none);
    }
    .progress-in {
      position: absolute;
      left: var(--crusher-skill-bar-fill-left, 0);
      top: var(--crusher-skill-bar-fill-top, 0);
      height: var(--crusher-skill-bar-fill-height, 100%);
      border-radius: var(--crusher-skill-bar-fill-radius, var(--crusher-radius-full));
      background-color: var(--crusher-skill-bar-fill-bg, var(--crusher-color-brand-primary));
      transition: width var(--crusher-motion-duration-slow) var(--crusher-motion-easing-inout);
    }
    .progress-in .percent-text {
      position: absolute;
      right: var(--crusher-skill-bar-percent-inset-inline-end, 0);
      top: var(--crusher-skill-bar-percent-inset-block-start, 0);
      white-space: nowrap;
      margin-top: var(--crusher-skill-bar-percent-bar-margin-top, 0);
    }
  `;

  static properties = {
    label: { type: String },
    percentage: { type: Number },
    percentPosition: { type: String, attribute: 'percent-position' },
  };

  constructor() {
    super();
    this.label = 'Skill';
    this.percentage = 50;
    this.percentPosition = 'header';
  }

  render() {
    const clampedPercentage = Math.max(0, Math.min(100, this.percentage));
    const percentText = `${clampedPercentage}%`;
    const fillWidth = `calc(${clampedPercentage}% - var(--crusher-skill-bar-fill-offset, 0px))`;
    const showHeaderPercent = this.percentPosition === 'header';
    const showBarPercent = this.percentPosition === 'bar';
    
    return html`
      <div class="skill-item">
        <div class="header">
          <h5 class="label">${this.label}</h5>
          ${showHeaderPercent ? html`<span class="percent-text">${percentText}</span>` : ''}
        </div>
        <div class="progress">
          <div class="progress-in" style="width: ${fillWidth}">
            ${showBarPercent ? html`<span class="percent-text">${percentText}</span>` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('crusher-skill-bar', CrusherSkillBar);
